/** @jsx jsx */
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import { modalIds, ModalsConsumer } from '../../../../contexts/ModalsContext';
import { getPrefilledSolutionValue } from '../../../../utils/getPrefilledSolutionValue';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import createButtonCss from '../../../ui/Button/Button';
import DotComponent from '../../../ui/DotComponent';
import * as styles from './index.styles';

export const defaultFields = {
  DescriptionLine1: { value: '' },
  DescriptionLine2: { value: '' },
  Title: { value: '' },
};

class NoResults extends SafePureComponent {
  fields = defaultsDeep(this.props.fields, defaultFields);

  safeRender() {
    const { rendering, sitecoreContext, t } = this.props;
    const { Title, DescriptionLine1, DescriptionLine2 } = this.fields;
    const jssPhonePlaceholder = get(rendering, 'placeholders.jss-phone');

    return (
      <div css={styles.wrapper}>
        <h2 css={styles.title}>
          <Text field={Title} />
          <DotComponent />
        </h2>
        <p css={styles.description}>
          <Text field={DescriptionLine1} />
        </p>
        {DescriptionLine2.value && (
          <p css={[styles.description, styles.descriptionSecondary]}>
            <Text field={DescriptionLine2} />
          </p>
        )}
        <div css={styles.contactBlock}>
          <ModalsConsumer>
            {({ openModal }) => (
              <button
                onClick={() =>
                  openModal(modalIds.enquiry, {
                    Solution: getPrefilledSolutionValue(sitecoreContext),
                  })
                }
                css={[createButtonCss(), styles.contactBtn]}
              >
                {t('GetInTouchCTA')}
              </button>
            )}
          </ModalsConsumer>

          {jssPhonePlaceholder && (
            <div css={styles.callUsBlock}>
              <Placeholder name="jss-phone" rendering={rendering} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

NoResults.displayName = 'NoResults';

NoResults.defaultProps = {
  t: key => key,
};

NoResults.propTypes = {
  fields: PropTypes.shape({
    DescriptionLine1: PropTypes.shape({
      value: PropTypes.string,
    }),
    DescriptionLine2: PropTypes.shape({
      value: PropTypes.string,
    }),
    Title: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  rendering: PropTypes.object,
  t: PropTypes.func,
};

export default withNamespaces()(NoResults);
